import {
  HttpClient,
  HttpErrorResponse,
  HttpParams
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, of } from 'rxjs';
import {
  AarResponse,
  ChartType,
  DagMonthResponse,
  DagResponse,
  EmailResponse,
  MaanedResponse,
  OppsummeringResponse,
  UkeResponse
} from './forbruk.types';
import { AnalyticsService } from '../analytics/analytics.service';
import { theTime } from 'src/app/utils/date-utils';

@Injectable({
  providedIn: 'root'
})
export class ForbrukService {
  constructor(
    private _httpClient: HttpClient,
    private analytics: AnalyticsService
  ) { }

  _chartTypes = new BehaviorSubject<ChartType>({
    Aar: { active: false, name: 'År', visible: true },
    Maaned: { active: false, name: 'Måned', visible: true },
    Dag: { active: true, name: 'Dag', visible: true },
    Time: { active: false, name: 'Time', visible: true }
  });
  _chartTypes$ = this._chartTypes.asObservable();

  getMaanedsforbruk(pris: boolean): Observable<MaanedResponse> {
    const params = new HttpParams().append('pris', pris ? 'true' : 'false');
    return this._httpClient.get<MaanedResponse>(
      'https://apiprivat.ishavskraft.no/forbruk/maaned',
      { params: params }
    );
  }

  getDagforbruk(dato: Date, pris: boolean): Observable<DagMonthResponse> {
    const params = new HttpParams().append('pris', pris ? 'true' : 'false');
    return this._httpClient.get<DagMonthResponse>(
      'https://apiprivat.ishavskraft.no/forbruk/dag/' +
      theTime(dato).toPlainDateString(),
      { params: params }
    );
  }

  getDagForbrukSiste(pris: boolean): Observable<DagMonthResponse> {
    const params = new HttpParams().append('pris', pris ? 'true' : 'false');
    return this._httpClient
      .get<DagMonthResponse>(
        'https://apiprivat.ishavskraft.no/forbruk/dag/siste',
        { params: params }
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.analytics.logEvent_errorFetch(
            'https://apiprivat.ishavskraft.no/forbruk',
            `Status ${error.status} ${error.statusText} - ${error.url}`
          );
          return of(null);
        })
      );
  }

  getForbrukTimeSiste(pris: boolean): Observable<DagResponse> {
    const params = new HttpParams().append('pris', pris ? 'true' : 'false');
    return this._httpClient.get<DagResponse>(
      'https://apiprivat.ishavskraft.no/forbruk/time/dag/siste',
      { params: params }
    );
  }

  getForbrukTimeDag(dato: Date, pris: boolean): Observable<DagResponse> {
    const params = new HttpParams().set('pris', pris ? 'true' : 'false');
    return this._httpClient.get<DagResponse>(
      'https://apiprivat.ishavskraft.no/forbruk/time/dag/' +
      theTime(dato).toPlainDateString(),
      { params: params }
    );
  }

  getForbrukUke(dato: Date, pris: boolean): Observable<UkeResponse> {
    const params = new HttpParams().set('pris', pris ? 'true' : 'false');
    return this._httpClient.get<UkeResponse>(
      'https://apiprivat.ishavskraft.no/forbruk/uke/' +
      theTime(dato).toPlainDateString(),
      { params: params }
    );
  }

  getForbrukUkeSiste(pris: boolean): Observable<UkeResponse> {
    const params = new HttpParams().set('pris', pris ? 'true' : 'false');
    return this._httpClient.get<UkeResponse>(
      'https://apiprivat.ishavskraft.no/forbruk/uke/siste',
      { params: params }
    );
  }

  getForbrukAar(pris: boolean, startAar: number): Observable<AarResponse> {
    const params = new HttpParams().set('pris', pris ? 'true' : 'false');
    return this._httpClient.get<AarResponse>(
      'https://apiprivat.ishavskraft.no/forbruk/aar/' + startAar,
      { params: params }
    );
  }

  getOppsummering() {
    return this._httpClient.get<OppsummeringResponse>(
      'https://apiprivat.ishavskraft.no/forbruk/oppsummering'
    );
  }

  getExcelfil(payload: string): Observable<EmailResponse> {
    //var headers = {
    //    headers: new HttpHeaders({
    //        'Content-Type': 'application/json'
    //    })
    //}
    return this._httpClient.post<EmailResponse>(
      'https://apiprivat.ishavskraft.no/forbruk/forbruksdetaljer',
      payload
    );
  }

  // requestBetalingsutsettelse(
  //   payload: string
  // ): Observable<BetalingsavtaleResponse> {
  //   return this._httpClient.post<BetalingsavtaleResponse>(
  //     'https://apiprivat.ishavskraft.no/faktura/betalingsavtale',
  //     payload
  //   );
  // }

  getChartType(): Observable<ChartType> {
    return this._chartTypes$;
  }

  setChartType(chartType: ChartType) {
    this._chartTypes.next(chartType);
  }
}
